module.exports = __webpack_public_path__ + "img/scratchbg.93f3174e.png";